import qs from "qs";

export const parseQueryParams = queryString => {
  const query = queryString && queryString.startsWith("?") ? queryString.substring(1) : queryString;
  return qs.parse(query);
};

export const stringifyQueryParams = queryParams => qs.stringify(queryParams);
